export default __webpack_public_path__ + "static/media/53.8651c3cd.png";